import _default from './Feed';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/views/Feed/index.js
// module id = 708
// module chunks = 0